import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import DoneIcon from '@mui/icons-material/Done';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import { Box, Button, CircularProgress, Grid, TextField, Typography, } from '@mui/material';
import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { useNavigate } from 'react-router-dom';
import * as Yup from "yup";
import { cfpBaseUrl } from '../../../network/urls';
import { documentValidation } from '../../../services/Functions';
import "../ChangeOfAttributes/ChangeOfAttributesForm.scss";
import { documentExtensions } from '../../../utils/PortalName';

const ChangeofAttributesupdatedocuments = () => {
    const initialValues = {
        // Required Documents Initial Values
        iv_applicant_cnic_front: null,
        iv_owenership_document: null,
        iv_electricityBill_document: null,
        iv_fbr_document: null
    }

    // Documents states
    const [applicantCNICFront, setApplicantCnicFront] = useState('');
    const [applicantCNICBack, setApplicantCnicBack] = useState('');
    const [owenershipDocument, setOwenershipDocument] = useState('');
    const [electricityBillDocument, setElectricityBillDocument] = useState('');
    const [fbrDocument, setFbrDocument] = useState('');


    // Thumbnail states
    const [applicantCNICFrontThumbnail, setApplicantCnicFrontThumbnail] = useState('');
    const [applicantCNICBackThumbnail, setApplicantCnicBackThumbnail] = useState('');
    const [owenershipDocumentThumbnail, setOwenershipDocumentThumbnail] = useState('');
    const [electricityBillDocumentThumbnail, setElectricityBillDocumentThumbnail] = useState('');
    const [fbrDocumentThumbnail, setFbrDocumentThumbnail] = useState('');

    // Error states
    const [applicantCNICFrontError, setApplicantCnicFrontError] = useState('');
    const [applicantCNICBackError, setApplicantCnicBackError] = useState('');
    const [owenershipDocumentError, setOwenershipDocumentError] = useState('');
    const [electricityBillDocumentError, setElectricityBillDocumentError] = useState('');
    const [fbrDocumentError, setFbrDocumentError] = useState('');


    const [connectionType, setConnectionType] = useState()
    const [applicantStatus, setApplicantStatus] = useState()
    const [isLoadingSpinner, setIsLoadingSpinner] = useState(false)

    const { state } = useLocation();
    const { dialogRowData } = state;
    const [dialogRowDataLocal, setDialogRowDataLocal] = useState();
    const { token, name } = useSelector((state) => state.auth)
    const navigate = useNavigate();
    useEffect(() => {
        console.log(dialogRowData, "dialogRowData")
    }, [dialogRowData])

    useEffect(() => {
        if (dialogRowData) {
            console.log(dialogRowData, 'Dialog Row Data')
            let dialogData = dialogRowData
            setDialogRowDataLocal(dialogData)
        }
    }, [dialogRowData])

    useEffect(() => {
        if (dialogRowData) {

            setConnectionType(dialogRowData.connectionType)
            setApplicantStatus(dialogRowData.applicantStatus)
        }
        if (dialogRowData.applicantCNICFront) {
            values.iv_applicant_cnic_front = dialogRowData.applicantCNICFront
            setApplicantCnicFrontThumbnail(dialogRowData.applicantCNICFront)
        }
        if (dialogRowData.applicantCNICBack) {
            values.iv_applicant_cnic_back = dialogRowData.applicantCNICBack
            setApplicantCnicBackThumbnail(dialogRowData.applicantCNICBack)
        }
        if (dialogRowData.owenershipDocument) {
            values.iv_owenership_document = dialogRowData.owenershipDocument
            setOwenershipDocumentThumbnail(dialogRowData.owenershipDocument)
        }
        if (dialogRowData.electricityBillDocument) {
            values.iv_electricityBill_document = dialogRowData.electricityBillDocument
            setElectricityBillDocumentThumbnail(dialogRowData.electricityBillDocument)
        }
        if (dialogRowData.fbrDocument) {
            values.iv_fbr_document = dialogRowData.fbrDocument
            setFbrDocumentThumbnail(dialogRowData.fbrDocument)
        }
    }, [dialogRowData])

    const { values, errors, touched, handleBlur, handleChange, handleSubmit } =
        useFormik({
            initialValues,
            validationSchema: Yup.object({
                // Required Documents Validation
                iv_applicant_cnic_front: Yup.mixed().required('Please upload cnic in jpg, jpeg, png or pdf format.'),
                iv_applicant_cnic_back: Yup.mixed().required('Please upload cnic in jpg, jpeg, png or pdf format.'),
                iv_owenership_document: Yup.mixed().required('Please upload ownership document in jpg, jpeg, png or pdf format.'),
                iv_electricityBill_document: Yup.mixed().required('Please upload electricity bill in jpg, jpeg, png or pdf format.'),

            }),
            onSubmit: async (values, { resetForm }) => {
                setIsLoadingSpinner(true);
                let applicationProgressId = dialogRowData.applicationProgressId;
                if (applicationProgressId == 0) {
                    applicationProgressId += 1
                }

                const myHeaders = new Headers();
                myHeaders.append("Authorization", token);
                myHeaders.append("Content-Type", "application/json");

                const raw = JSON.stringify({
                    "applicationId": dialogRowData.applicationId,
                    "applicationProgressId": applicationProgressId,
                    "objectionStatus": 2,
                    "remarks": "Documents Re-Uploaded.",
                    "remarksDetail": "",
                    "applicantCNICFront": applicantCNICFrontThumbnail,
                    "applicantCNICBack": applicantCNICBackThumbnail,
                    "electricityBill": electricityBillDocumentThumbnail,
                    "ownershipImage": owenershipDocumentThumbnail,
                    "fbrDocument": fbrDocumentThumbnail,
                    "applicantCNICFrontFlag": 2,
                    "applicantCNICBackFlag": 2,
                    "electricityBillFlag": 2,
                    "ownershipImageFlag": 2,
                    "fbrDocumentFlag":fbrDocumentThumbnail ? 2 : null
                });

                const requestOptions = {
                    method: "POST",
                    headers: myHeaders,
                    body: raw,
                    redirect: "follow"
                };

                await fetch(cfpBaseUrl + "changeOfAttributes/reuploadDocuments", requestOptions)
                    .then((response) => response.json())
                    .then(result => {
                        if (result.status === "200") {
                            navigate('/change-of-attributes-table')
                        }
                        else {
                            setIsLoadingSpinner(false)
                            console.log(result.message);
                        }
                    })
                    .catch(error => {
                        setIsLoadingSpinner(false)
                        console.log(error);
                    });
            }
        })

    //Function to set states of documents
    const ApplicantCnicFront = (event) => {
        handleChange(event);
        if (event.target.files.length > 0) {
            let file = event.target.files[0];
            let fileName = file.name
            let fileNameArray = fileName.split('.')
            let extension = fileNameArray[fileNameArray.length - 1]
            const maxSize = 2 * 1024 * 1024; // 2MB in bytes
            const documentValidate = documentValidation(file, maxSize)
            if (documentValidate === 1) {
                const newFileName = "applicantCNICFrontFront." + extension;
                const renamedFile = new File([file], newFileName, { type: file.type });
                setApplicantCnicFront(renamedFile);
                const reader = new FileReader();

                reader.onload = (e) => {
                    // Set the thumbnail image as the data URL
                    setApplicantCnicFrontThumbnail(e.target.result);
                };

                reader.readAsDataURL(file);
            } else if (documentValidate === 2) {
                setApplicantCnicFrontError("File size exceeds " + maxSize / 1024 / 1024 + "MB limit.");
            } else {
                setApplicantCnicFrontError("Invalid file type. Only JPG, PNG, and PDF are allowed.");
            }
        }
    }

    const ApplicantCnicBack = (event) => {
        handleChange(event);
        if (event.target.files.length > 0) {
            let file = event.target.files[0];
            let fileName = file.name
            let fileNameArray = fileName.split('.')
            let extension = fileNameArray[fileNameArray.length - 1]
            const maxSize = 2 * 1024 * 1024; // 2MB in bytes
            const documentValidate = documentValidation(file, maxSize)
            if (documentValidate === 1) {
                const newFileName = "applicantCNICFrontBack." + extension;
                const renamedFile = new File([file], newFileName, { type: file.type });
                setApplicantCnicBack(renamedFile);
                const reader = new FileReader();

                reader.onload = (e) => {
                    // Set the thumbnail image as the data URL
                    setApplicantCnicBackThumbnail(e.target.result);
                };

                reader.readAsDataURL(file);
            } else if (documentValidate === 2) {
                setApplicantCnicBackError("File size exceeds " + maxSize / 1024 / 1024 + "MB limit.");
            } else {
                setApplicantCnicBackError("Invalid file type. Only JPG, PNG, and PDF are allowed.");
            }
        }
    }

    const OwenershipDocument = (event) => {
        handleChange(event);
        if (event.target.files.length > 0) {
            let file = event.target.files[0];
            let fileName = file.name
            let fileNameArray = fileName.split('.')
            let extension = fileNameArray[fileNameArray.length - 1]
            const maxSize = 2 * 1024 * 1024; // 2MB in bytes
            const documentValidate = documentValidation(file, maxSize)
            if (documentValidate === 1) {
                const newFileName = "owenershipDocument." + extension;
                const renamedFile = new File([file], newFileName, { type: file.type });
                setOwenershipDocument(renamedFile);
                const reader = new FileReader();
                reader.onload = (e) => {
                    // Set the thumbnail image as the data URL
                    setOwenershipDocumentThumbnail(e.target.result);
                };
                reader.readAsDataURL(file);
            }
            else if (documentValidate === 2) {
                setOwenershipDocumentError("File size exceeds " + maxSize / 1024 / 1024 + "MB limit.");
            } else {
                setOwenershipDocumentError("Invalid file type. Only JPG, PNG, and PDF are allowed.");
            };
        }
    }

    const ElectricityBillDocument = (event) => {
        handleChange(event);
        if (event.target.files.length > 0) {
            let file = event.target.files[0];
            let fileName = file.name
            let fileNameArray = fileName.split('.')
            let extension = fileNameArray[fileNameArray.length - 1]
            const maxSize = 2 * 1024 * 1024; // 2MB in bytes
            const documentValidate = documentValidation(file, maxSize)
            if (documentValidate === 1) {
                const newFileName = "electricityBillDocument." + extension;
                const renamedFile = new File([file], newFileName, { type: file.type });
                setElectricityBillDocument(renamedFile);
                const reader = new FileReader();
                reader.onload = (e) => {
                    // Set the thumbnail image as the data URL
                    setElectricityBillDocumentThumbnail(e.target.result);
                };
                reader.readAsDataURL(file);
            }
            else if (documentValidate === 2) {
                setElectricityBillDocumentError("File size exceeds " + maxSize / 1024 / 1024 + "MB limit.");
            } else {
                setElectricityBillDocumentError("Invalid file type. Only JPG, PNG, and PDF are allowed.");
            };
        }
    }


    const fbrDocuments = (event) => {
        handleChange(event);
        if (event.target.files.length > 0) {
            let file = event.target.files[0];
            let fileName = file.name
            let fileNameArray = fileName.split('.')
            let extension = fileNameArray[fileNameArray.length - 1]
            const maxSize = 2 * 1024 * 1024; // 2MB in bytes
            const documentValidate = documentValidation(file, maxSize)
            if (documentValidate === 1) {
                const newFileName = "fbrDocument." + extension;
                const renamedFile = new File([file], newFileName, { type: file.type });
                setFbrDocument(renamedFile);
                const reader = new FileReader();
                reader.onload = (e) => {
                    // Set the thumbnail image as the data URL
                    setFbrDocumentThumbnail(e.target.result);
                };
                reader.readAsDataURL(file);
            }
            else if (documentValidate === 2) {
                setFbrDocumentError("File size exceeds " + maxSize / 1024 / 1024 + "MB limit.");
            } else {
                setFbrDocumentError("Invalid file type. Only JPG, PNG, and PDF are allowed.");
            };
        }
    }
    return (
        console.log(dialogRowData, 'dia dia dia'),
        <Grid container className='nC'>
            <Box className='nCContainer'>
                <Typography variant='h6' className='heading'>
                    Change of Attributes Form
                </Typography>
                <Box className="progressBarBackground">
                    <Box className="progressBarContainer">
                        <Box className="pbDocGroup">
                            <Typography className="badge">
                                {
                                    (dialogRowData.applicantCNICFront && dialogRowData.applicantCNICBack) || (applicantCNICFront && applicantCNICBack)
                                        ?
                                        <Box className='backgroundAttached'>
                                            <DoneIcon className='icon' />
                                        </Box> :
                                        <p className='backgroundUnAttached'>1</p>
                                }
                            </Typography>
                            <Typography className='badgeText'>Applicant's CNIC.</Typography>
                        </Box>
                        <Box className="pbDocGroup">
                            <Typography className="badge">
                                {
                                    dialogRowData.owenershipDocument || owenershipDocument
                                        ?
                                        <Box className='backgroundAttached'>
                                            <DoneIcon className='icon' />
                                        </Box> :
                                        <p className='backgroundUnAttached'>2</p>
                                }
                            </Typography>
                            <Typography className='badgeText'>Proof of Ownership</Typography>
                        </Box>
                        <Box className="pbDocGroup">
                            <Typography className="badge">
                                {
                                    dialogRowData.electricityBillDocument || electricityBillDocument
                                        ?
                                        <Box className='backgroundAttached'>
                                            <DoneIcon className='icon' />
                                        </Box> :
                                        <p className='backgroundUnAttached'>3</p>
                                }
                            </Typography>
                            <Typography className='badgeText'>Electricity Bill</Typography>
                        </Box>

                    </Box>
                </Box>

                <form className='ncform' >
                    <Typography variant="h6" className='groupTitle' >
                        Application Details
                    </Typography>
                    <Grid container spacing={2} sx={{ marginLeft: '0 !important' }}>
                        <Grid item xs={2}>
                            <Typography className='fieldLabel' > Application Id</Typography>
                            <TextField
                                required
                                type='text'
                                name="applicationId"
                                value={dialogRowData.applicationId}
                                disabled
                                id="applicationId"
                                className='textInputField'
                            />
                        </Grid>

                    </Grid>
                    <Typography variant="h6" className='groupTitle'>
                        Documents
                    </Typography>
                    <Grid container spacing={1} className='documentsContainer' >
                        <Grid item lg='2' >
                            <Typography className='documentLabel' >1- Applicant's CNIC.</Typography>
                            <Box className='documentError'>{(errors.iv_applicant_cnic_front && touched.iv_applicant_cnic_front) || (errors.iv_applicant_cnic_back && touched.iv_applicant_cnic_back) ? (errors.iv_applicant_cnic_front) : null}</Box>
                        </Grid>
                        <Grid item lg='1'>
                            {
                                dialogRowData.applicantCNICFront ?
                                    <Grid container>
                                        <Grid item sm={6}>
                                            <img src={applicantCNICFrontThumbnail} style={{ width: '50%' }} />
                                        </Grid>
                                        {
                                            (!dialogRowData.applicantCNICFrontFlag || dialogRowData.applicantCNICFrontFlag === -1) &&
                                            <Grid item sm={6}>
                                                <Button varient='contained' component="label" startIcon={<DeleteOutlinedIcon sx={{ color: 'red' }} />}  >

                                                    <input hidden accept={documentExtensions} id='iv_applicant_cnic_front' name='iv_applicant_cnic_front' type="file" onChange={ApplicantCnicFront} />
                                                </Button>
                                            </Grid>
                                        }
                                    </Grid>
                                    :
                                    applicantCNICFront ?
                                        <>
                                            <Button varient='contained' component="label" startIcon={<DeleteOutlinedIcon sx={{ color: 'red' }} onClick={() => { setApplicantCnicFront('') }} />}  >
                                                {applicantCNICFrontThumbnail && <img src={applicantCNICFrontThumbnail} alt="Applicant CNIC" width="100" />}
                                            </Button>
                                        </>
                                        :
                                        <>
                                            <Button variant="contained" component="label" startIcon={<FileUploadOutlinedIcon />}  >
                                                Upload
                                                <input hidden accept={documentExtensions} id='iv_applicant_cnic_front' name='iv_applicant_cnic_front' type="file" onChange={ApplicantCnicFront} />
                                            </Button>
                                        </>
                            }
                        </Grid>
                        <Grid item lg='1'>
                            {
                                dialogRowData.applicantCNICBack ?
                                    <Grid container>
                                        <Grid item sm={6}>
                                            <img src={applicantCNICBackThumbnail} style={{ width: '50%' }} />
                                        </Grid>
                                        {
                                            dialogRowData.applicantCNICBackFlag === -1 &&
                                            <Grid item sm={6}>
                                                <Button varient='contained' component="label" startIcon={<DeleteOutlinedIcon sx={{ color: 'red' }} />}  >

                                                    <input hidden accept={documentExtensions} id='iv_applicant_cnic_back' name='iv_applicant_cnic_back' type="file" onChange={ApplicantCnicBack} />
                                                </Button>
                                            </Grid>
                                        }
                                    </Grid>
                                    :
                                    applicantCNICBack ?
                                        <>
                                            <Button varient='contained' component="label" startIcon={<DeleteOutlinedIcon sx={{ color: 'red' }} onClick={() => { setApplicantCnicBack('') }} />}  >
                                                {applicantCNICBackThumbnail && <img src={applicantCNICBackThumbnail} alt="Applicant CNIC" width="100" />}
                                            </Button>
                                        </>
                                        :
                                        <>
                                            <Button variant="contained" component="label" startIcon={<FileUploadOutlinedIcon />}  >
                                                Upload
                                                <input hidden accept={documentExtensions} id='iv_applicant_cnic_back' name='iv_applicant_cnic_back' type="file" onChange={ApplicantCnicBack} />
                                            </Button>
                                        </>
                            }
                        </Grid>
                        <Grid item lg='2' >
                            <Typography className='documentLabel' >2- Proof of Ownership</Typography>
                            <Box className='documentError'>{errors.iv_owenership_document && touched.iv_owenership_document ? (errors.iv_owenership_document) : null}</Box>
                        </Grid>
                        <Grid item lg='2'>
                            {
                                dialogRowData.owenershipDocument ?
                                    <Grid container>
                                        <Grid item sm={6}>
                                            <img src={owenershipDocumentThumbnail} style={{ width: '50%' }} />
                                        </Grid>
                                        {
                                            dialogRowData.ownershipImageFlag === -1 &&
                                            <Grid item sm={6}>
                                                <Button varient='contained' component="label" startIcon={<DeleteOutlinedIcon sx={{ color: 'red' }} />}  >

                                                    <input hidden accept={documentExtensions} id='iv_owenership_document' name='iv_owenership_document' type="file" onChange={OwenershipDocument} />
                                                </Button>
                                            </Grid>
                                        }
                                    </Grid>
                                    :
                                    owenershipDocument ?
                                        <>
                                            <Button varient='contained' component="label" startIcon={<DeleteOutlinedIcon sx={{ color: 'red' }} onClick={() => { setOwenershipDocument('') }} />}  >
                                                {owenershipDocumentThumbnail && <img src={owenershipDocumentThumbnail} alt="Applicant CNIC" width="100" />}
                                            </Button>
                                        </>
                                        :
                                        <>
                                            <Button variant="contained" component="label" startIcon={<FileUploadOutlinedIcon />}  >
                                                Upload
                                                <input hidden accept={documentExtensions} id='iv_owenership_document' name='iv_owenership_document' type="file" onChange={OwenershipDocument} />
                                            </Button>
                                        </>
                            }
                        </Grid>
                        <Grid item lg='2' >
                            <Typography className='documentLabel' >3- Electricity Bill</Typography>
                            <Box className='documentError'>{errors.iv_electricityBill_document && touched.iv_electricityBill_document ? (errors.iv_electricityBill_document) : null}</Box>
                        </Grid>
                        <Grid item lg='2'>
                            {
                                dialogRowData.electricityBillDocument ?
                                    <Grid container>
                                        <Grid item sm={6}>
                                            <img src={electricityBillDocumentThumbnail} style={{ width: '50%' }} />
                                        </Grid>
                                        {
                                            dialogRowData.electricityBillFlag === -1 &&
                                            <Grid item sm={6}>
                                                <Button varient='contained' component="label" startIcon={<DeleteOutlinedIcon sx={{ color: 'red' }} />}  >

                                                    <input hidden accept={documentExtensions} id='iv_electricityBill_document' name='iv_electricityBill_document' type="file" onChange={ElectricityBillDocument} />
                                                </Button>
                                            </Grid>
                                        }
                                    </Grid>
                                    :
                                    electricityBillDocument ?
                                        <>
                                            <Button varient='contained' component="label" startIcon={<DeleteOutlinedIcon sx={{ color: 'red' }} onClick={() => { setElectricityBillDocument('') }} />}  >
                                                {electricityBillDocumentThumbnail && <img src={electricityBillDocumentThumbnail} alt="Applicant CNIC" width="100" />}
                                            </Button>
                                        </>
                                        :
                                        <>
                                            <Button variant="contained" component="label" startIcon={<FileUploadOutlinedIcon />}  >
                                                Upload
                                                <input hidden accept={documentExtensions} id='iv_electricityBill_document' name='iv_electricityBill_document' type="file" onChange={ElectricityBillDocument} />
                                            </Button>
                                        </>
                            }
                        </Grid>


                        {
                            dialogRowData.fbrDocument &&
                            <>
                                <Grid item lg='2' >
                                    <Typography className='documentLabel' >4- FBR Document</Typography>
                                    <Box className='documentError'>{errors.iv_fbr_document && touched.iv_fbr_document ? (errors.iv_fbr_document) : null}</Box>
                                </Grid>
                                <Grid item lg='2'>
                                    {
                                        dialogRowData.fbrDocument ?
                                            <Grid container>
                                                <Grid item sm={6}>
                                                    <img src={fbrDocumentThumbnail} style={{ width: '50%' }} />
                                                </Grid>
                                                {
                                                    dialogRowData.fbrDocumentFlag === -1 &&
                                                    <Grid item sm={6}>
                                                        <Button varient='contained' component="label" startIcon={<DeleteOutlinedIcon sx={{ color: 'red' }} />}  >

                                                            <input hidden accept={documentExtensions} id='iv_fbr_document' name='iv_fbr_document' type="file" onChange={fbrDocuments} />
                                                        </Button>
                                                    </Grid>
                                                }
                                            </Grid>
                                            :
                                            fbrDocument ?
                                                <>
                                                    <Button varient='contained' component="label" startIcon={<DeleteOutlinedIcon sx={{ color: 'red' }} onClick={() => { setFbrDocument('') }} />}  >
                                                        {fbrDocumentThumbnail && <img src={fbrDocumentThumbnail} alt="Applicant CNIC" width="100" />}
                                                    </Button>
                                                </>
                                                :
                                                <>
                                                    <Button variant="contained" component="label" startIcon={<FileUploadOutlinedIcon />}  >
                                                        Upload
                                                        <input hidden accept={documentExtensions} id='iv_fbr_document' name='iv_fbr_document' type="file" onChange={fbrDocuments} />
                                                    </Button>
                                                </>
                                    }
                                </Grid>
                            </>
                        }



                    </Grid>
                    <Box sx={{ marginTop: '8%', textAlign: 'right' }}>
                        <Button sx={{ width: '10%', marginLeft: '1%', marginBottom: '1%' }} variant='contained' component="label" type='submit' onClick={handleSubmit} disabled={isLoadingSpinner}>
                            {isLoadingSpinner ? (
                                <Box sx={{ display: 'flex' }}>
                                    <CircularProgress />
                                </Box>
                            ) : (
                                'Submit'
                            )}
                        </Button>
                    </Box>
                </form >
            </Box >
        </Grid >
    )
}

export default ChangeofAttributesupdatedocuments
